<template>
  <div class="newsDetail">
    <h1>{{ news.newsTitle ? news.newsTitle : "" }}</h1>
    <h3>{{ news.newsDate ? news.newsDate.substring(0, 10) : "" }}</h3>
    <quill-editor
      ref="myQuillEditor"
      v-model="news.newsContent"
      :options="editorOptions"
    >
    </quill-editor>
  </div>
</template>

<script>
import { getNewsList } from "@/api/news";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  name: "NewsDetail",
  components: { quillEditor },
  data() {
    return {
      // news: this.$store.getters.newsActive,
      news: [],
      newsId: this.$route.query.id,
      editorOptions: {},
    };
  },
  created() {
    this.getNewsDetails();
  },
  mounted() {
    // 使用 ref 获取 Quill 实例
    const quill = this.$refs.myQuillEditor.quill;

    // 手动设置 readOnly 属性
    quill.enable(false); // 或者 quill.root.setAttribute('contenteditable', false);
  },
  methods: {
    getNewsDetails() {
      let data = {
        id: this.newsId,
      };
      getNewsList(data).then((res) => {
        this.news = res.data.records[0];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.newsDetail {
  padding: 0 200px;
  margin-top: 150px;
  min-height: 100vh;
  > h1 {
    text-align: center;
    margin: 0 15px;
  }
  > h3 {
    margin: 50px 15px 20px 15px;
    text-align: right;
  }
}
/deep/.ql-toolbar {
  display: none;
}
/deep/.ql-container {
  border: none;
}
@media screen and (max-width: 800px) {
  .newsDetail {
    padding: 0;
    /deep/.ql-size-large {
      font-size: 16px;
    }
  }
}
</style>